import MapGeolocationEnIcon from './MapGeolocationEnIcon'
import MapGeolocationRuIcon from './MapGeolocationRuIcon'

type Props = {icon: 'ya-ru' | 'ya-en'}

export function MapIcon({icon}: Props) {
  return icon === 'ya-ru' ? <MapGeolocationRuIcon /> : <MapGeolocationEnIcon />
}
